import './Messaging.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import classNames from 'classnames';
import moment from 'moment';

import { emptyMessaging, getConversations, getMessages, postConversationAsRead, postMessage, setConversation, setMessage } from 'containers/Messaging/store/actions';

import Avatar from 'components/Avatar';
import Button from 'components/Button';
import H1 from 'components/H1';
import NewMessageForm from './NewMessageForm';
import PageContent from 'components/PageContent';
import LoadingCircle from "../../components/LoadingCircle";

class Messaging extends React.Component {
    constructor() {
        super();

        this.messagesRef = React.createRef();

        this.messagesTimer = null;
    }

    componentDidMount() {
        document.body.classList.add('messaging-page');

        this.props.getConversations();
    }

    componentWillUnmount() {
        document.body.classList.remove('messaging-page');

        window.clearTimeout(this.messagesTimer);
        this.props.emptyMessaging();
    }

    _getMessages(hideSpinner, dontMarkAsRead) {
        if(this.props.messaging.conversation.id != null) {
            this.props.getMessages(hideSpinner)
                .then((res) => {
                    setTimeout(() => {
                        if(this.messagesRef.current != null) {
                            this.messagesRef.current.scrollTop = this.messagesRef.current.scrollHeight;
                        }
                    }, 1);

                    if(dontMarkAsRead !== true) {
                        this.props.postConversationAsRead();
                    }

                    this.messagesTimer = setTimeout(() => {
                        this._getMessages(true, true);
                    }, 5000);
                });
        }
    }

    handleNameClick(sender) {
        if(sender.isFreelancer === true) {
            this.props.changeLocation(`/freelancer/${sender.id}`)
        }
    }

    handleSelectConversation(conversation) {
        this.props.setConversation(conversation);

        setTimeout(() => {
            this._getMessages();
        }, 10);
    }

    handleSubmit() {
        return new Promise((resolve) => {
            this.props.postMessage()
                .then((res) => {
                    this._getMessages(true);
                    resolve(res);
                })
        });
    }

    _renderMessageBlock(messageBlock) {
        return (
            <div className="conversation__block">
                <div className="conversation__date">
                    <span>
                        {moment(messageBlock.date).format('MM / DD / YYYY')}
                    </span>
                </div>
                {messageBlock.messages.map((message) => (
                    <div className="conversation__message">
                        <Avatar
                            className={message.sender.isFreelancer === true ? 'a-avatar--clickable' : null}
                            imageUrl={message.sender.company != null ? message.sender.company.profilePicUrl : message.sender.profilePicUrl}
                            onClick={this.handleNameClick.bind(this, message.sender)}
                            size="medium"
                        />
                        <div className="conversation__message-content">
                            <div className={`conversation__message-name ${message.sender.isFreelancer === true ? 'conversation__message-name--clickable' : ''}`} onClick={this.handleNameClick.bind(this, message.sender)}>
                                {message.sender.firstName} {message.sender.lastName} &bull; <span>{moment(message.created_at).format('h:mm A')}</span>
                            </div>
                            <div className="conversation__message-text">
                                {message.parts.map((part) => (
                                    <p>
                                        {part.body}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    render() {
        return (
            <PageContent className="messaging">
                <H1>
                    Messages
                </H1>

                {this.props.messaging.isFetchingConversations === true ? (
                    <div className="messaging--wrapper">
                        <LoadingCircle />
                    </div>
                ) : (
                    <div className="messaging--wrapper">
                        <div className="messaging__conversations">
                            {this.props.messaging.conversations.length > 0 ? (
                                <ul className="conversations-list">
                                    {this.props.messaging.conversations.map((conversation) => {
                                        let otherParticipant = conversation.participants.filter((participant) => participant.id !== this.props.auth.user.id)[0];
                                        return (
                                            <li key={conversation.id}>
                                                <Button className={classNames(
                                                    'conversations-list__preview',
                                                    {
                                                        'conversations-list__preview--active': this.props.messaging.conversation.id === conversation.id,
                                                        'conversations-list__preview--has-unread': conversation.hasUnreadMessages === true
                                                    }
                                                )}
                                                        noStyles
                                                        onClick={this.handleSelectConversation.bind(this, conversation)}>
                                                    <Avatar imageUrl={otherParticipant.profilePicUrl} />

                                                    <div className="conversations-list__preview__metadata">
                                                        <div className="conversations-list__preview__name">
                                                            {`${otherParticipant.firstName || ''} ${otherParticipant.lastName || ''}`}
                                                        </div>

                                                        <div className="conversations-list__preview__subject">
                                                            {conversation.subject}
                                                        </div>
                                                    </div>
                                                </Button>
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                <span>You are not part of any conversations at this time.</span>
                            )}
                        </div>

                        <div className="messaging__conversation">
                            {this.props.messaging.isFetchingMessages === true ? (
                                <div className="messaging__conversation--inner">
                                    <LoadingCircle />
                                </div>
                            ) : (
                                <div className="messaging__conversation--inner" ref={this.messagesRef}>
                                    {this.props.messaging.messages.map((messageBlock) => this._renderMessageBlock(messageBlock))}
                                </div>
                            )}

                            {Object.keys(this.props.messaging.conversation).length > 0 ? (
                                <NewMessageForm
                                    error={this.props.messaging.error}
                                    handleSubmit={this.handleSubmit.bind(this)}
                                    isSending={this.props.messaging.isSending}
                                    message={this.props.messaging.message}
                                    setMessage={this.props.setMessage.bind(this)}
                                />
                            ) : null}
                        </div>
                    </div>
                )}

            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        messaging: state.messaging
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        emptyMessaging: () => dispatch(emptyMessaging()),
        getConversations: () => dispatch(getConversations()),
        getMessages: (hideSpinner) => dispatch(getMessages(hideSpinner)),
        postConversationAsRead: () => dispatch(postConversationAsRead()),
        postMessage: () => dispatch(postMessage()),
        setConversation: (conversation) => dispatch(setConversation(conversation)),
        setMessage: (message) => dispatch(setMessage(message))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Messaging);



// WEBPACK FOOTER //
// ./src/containers/Messaging/index.js